module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('header-component'), _vm._v(" "), (_vm.$route.params.type == 0) ? _c('div', {
    staticClass: "container registation_content g-pt-25 g-pb-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('account-type', {
    on: {
      "clicked": function($event) {
        return _vm.GetForm()
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.type != 0) ? _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../../static/assets/include/svg/svg-bg1.svg')",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container registation_content g-pt-50 g-pb-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "g-max-width-645 text-center mx-auto g-mb-0"
  }, [_c('h2', {
    staticClass: "h2 mb-3"
  }, [_vm._v(_vm._s(_vm.registrationType) + " Registration Form")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSubmitFail),
      expression: "isSubmitFail"
    }],
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "errorDiv",
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.isSubmitFail = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('strong', [_vm._v("Error!")]), _vm._v(" Please complete the form to proceed with\n            the submission\n          ")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "registration-authority"
  }, [_vm._v("\n              Required fields are denoted with an asterisk\n            ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "registration-authority"
  }, [_vm._v("\n              " + _vm._s(_vm.noteLabel) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('non-profit-organization-details', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult
    }
  }), _vm._v(" "), _c('username-and-password', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult
    },
    on: {
      "clicked": function($event) {
        return _vm.IsEmailAddressValid()
      },
      "confirm": function($event) {
        return _vm.ValidateConfirmEmail()
      }
    }
  }), _vm._v(" "), _c('participant-information', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "ContactValidationResult": _vm.ContactValidationResult,
      "BusinessTypeIndividual": _vm.BusinessTypeIndividual,
      "BusinessTypeBusiness": _vm.BusinessTypeBusiness,
      "BusinessTypeNonProfit": _vm.BusinessTypeNonProfit,
      "Suffix": _vm.Suffix,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "State": _vm.State
    },
    on: {
      "npiForBusiness": function($event) {
        return _vm.ValidateNpiNumberForBusinessType()
      },
      "npiIsDirty": function($event) {
        return _vm.ValidateNpiNumber()
      }
    }
  }), _vm._v(" "), _c('office-location-information', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "OfficeLocationValidationResult": _vm.OfficeLocationValidationResult,
      "State": _vm.State,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "IsValidNPI": _vm.IsValidNPI,
      "IsAddressValidating": _vm.IsAddressValidating
    },
    on: {
      "addressCheck": function($event) {
        return _vm.ValidateAddress()
      }
    }
  }), _vm._v(" "), _c('eye-doctor-information', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "EyeDoctorValidation": _vm.EyeDoctorValidation,
      "Suffix": _vm.Suffix,
      "State": _vm.State
    },
    on: {
      "npiIsDirtyBusiness": _vm.ValidateNpiNumberEyeDoctor
    }
  }), _vm._v(" "), _c('association-and-communication', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "CheckboxBusiness": _vm.CheckboxBusiness
    }
  }), _vm._v(" "), _c('TermAgreementAndBaa', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "BusinessEmail": _vm.BusinessEmail,
      "TermsEmail": _vm.TermsEmail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-30"
  }, [_c('button', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10 g-font-size-18--md g-font-size-16",
    attrs: {
      "disabled": !_vm.EnablebCheck(),
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitForm()
      }
    }
  }, [_vm._v("\n                  Submit\n                ")])])], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-max-width-645 text-center mx-auto g-mb-0"
  }, [_c('h2', {
    staticClass: "h2 mb-3"
  }, [_vm._v("Registration Form")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "registration-description"
  }, [_vm._v("\n              Complete the information below to register for a charitable\n              account. Upon submitting the form, you will be sent an email\n              confirmation with a link to activate your account. If you have\n              any questions or concerns, please email us at\n              "), _c('a', {
    staticClass: "g-font-size-18",
    attrs: {
      "href": "mailto:support@onesight.org",
      "target": "_blank"
    }
  }, [_vm._v("support@onesight.org")]), _vm._v(".\n            ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-635d2444", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-635d2444"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/Registration.vue
// module id = 515
// module chunks = 3